import { Component, ElementRef, HostListener, inject, input, linkedSignal, model, OnInit, output, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TranslocoDirective } from '@jsverse/transloco';
import { TrapFocusComponent } from 'remarketing-ui-components-lib';
import { SaComponent, UtilityService } from 'smartauction-frontend-micro-library';
import { SavedSearchItem, SearchService } from 'remarketing-angular-library';

@Component({
    selector: 'app-saved-search-summary-dropdown',
    templateUrl: './saved-search-summary-dropdown.component.html',
    styleUrls: ['./saved-search-summary-dropdown.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, RouterLink]
})
export class SavedSearchSummaryDropdownComponent extends SaComponent implements OnInit {
  readonly disabled = input(true);
  readonly selected = model<string[]>([]);
  readonly hasSavedSearchesChange = output<boolean>();
  @ViewChild('checkboxes') checkboxes: ElementRef;

    private readonly searchService = inject(SearchService);
    private readonly utilityService = inject(UtilityService);

  readonly maxSelectedItems = 5;
  savedSearches: SavedSearchItem[] = [];
  componentId = this.utilityService.generateId();

  readonly showDropDown = linkedSignal({
    source: this.disabled,
    computation: () => false
  });

  get hasSavedSearches(): boolean {
    return this.savedSearches.length > 0;
  }

  ngOnInit(): void {
    this.searchService.savedSearches.pipe(takeUntil(this.destroyed$)).subscribe(savedSearches => {
      this.savedSearches = savedSearches;
      this.hasSavedSearchesChange.emit(this.hasSavedSearches);
    });
    this.searchService.retrieveSavedSearches();
  }

    toggleDropdown(): void {
    if (this.disabled()) {
      return;
    }
    this.showDropDown.update(value => !value);
  }

    @HostListener('click', ['$event'])
    onHostClick(event: MouseEvent): void {
      event.stopPropagation();
    }

    @HostListener('document:click')
    onDocumentClick(): void {
      this.showDropDown.set(false);
    }

  get totalSelected(): number {
    return this.selected().length;
  }

  get isMaxSelectionReached(): boolean {
    return this.totalSelected >= this.maxSelectedItems;
  }

  isSelected(savedSearch: SavedSearchItem): boolean {
    return this.selected().includes(savedSearch.id);
  }

  toggleSelection(savedSearch: SavedSearchItem): void {
    if (this.isSelected(savedSearch)) {
      this.selected.set(this.selected().filter(id => id !== savedSearch.id));
    } else if (!this.isMaxSelectionReached) {
      this.selected.set([...this.selected(), savedSearch.id]);
    }
  }
}
